import React from "react";

export default function DoctorMiniCard({
  avatarUrl,
  initials,
  name,
  specialty,
  subtitle,
  actionLabel,
  onAction,
  onClick,
}) {
  const handleAction = (e) => {
    e.stopPropagation(); // prevent triggering onClick on card
    onAction?.();
  };

  return (
    <button type="button" onClick={onClick} className="p2-doc-mini">
      {/* Avatar */}
      <div className="p2-doc-mini-avatar">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={name || "Doctor"}
            className="p2-doc-mini-avatar-img"
          />
        ) : (
          <span className="p2-doc-mini-avatar-initials">
            {initials || (name ? name[0] : "D")}
          </span>
        )}
      </div>

      {/* Main Text */}
      <div className="p2-doc-mini-main">
        <p className="p2-doc-mini-name">{name || "Mjek pa emër"}</p>
        <p className="p2-doc-mini-specialty">
          {specialty || "Specialitet i pa specifikuar"}
        </p>

        {subtitle && (
          <p className="p2-doc-mini-subtitle">{subtitle}</p>
        )}
      </div>

      {/* Action (NO nested button!) */}
      {actionLabel && (
        <span
          role="button"
          tabIndex={0}
          className="p2-doc-mini-action"
          onClick={handleAction}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") handleAction(e);
          }}
        >
          {actionLabel}
        </span>
      )}
    </button>
  );
}
